<div class="visitor-registration-summary">
    <h1>{{'Summary' | translate:
        ['tmc-yard.widgets.registration-terminal.visitor-registration-qrcode.title',
        translationService.language]}}</h1>

    <h2>
      {{'Hinweis' | translate:
        ['tmc-yard.widgets.registration-terminal.visitor-registration-qrcode.description', translationService.language]}}
    </h2>

    <mat-card>
      <sc-flex >
        <div class="qr-code-box">
          <qrcode class="qr-code" *ngIf="qrCodeContent" [scale]="qrScale"
              [colorDark]="darkMode?'#ffffff':'#000000'" [colorLight]="darkMode?'#000000':'#ffffff'"
              [qrdata]="qrCodeContent" [errorCorrectionLevel]="'M'"></qrcode>
        </div>
        <table>
            <tr>
              <td class="label"><label>{{'Company' | translate:
                      ['tmc-yard.widgets.registration-terminal.visitor-registration-summary.label.company',
                      translationService.language]}}:</label></td>
              <td class="bold">{{company}}</td>
          </tr>
            <tr>
                <td class="label"><label>{{'Name' | translate:
                        ['tmc-yard.widgets.registration-terminal.visitor-registration-summary.label.name',
                        translationService.language]}}:</label></td>
                <td class="bold">{{lastname}}</td>
            </tr>
            <tr>
                <td class="label"><label>{{'Firstname' | translate:
                        ['tmc-yard.widgets.registration-terminal.visitor-registration-summary.label.firstname',
                        translationService.language]}}:</label></td>
                <td class="bold">{{firstname}}</td>
            </tr>
            <tr>
              <td class="label"><label>{{'Numberplate' | translate:
                      ['tmc-yard.widgets.registration-terminal.visitor-registration-summary.label.numberPlate',
                      translationService.language]}}:</label></td>
              <td class="bold">{{numberPlate}}</td>
          </tr>
        </table>
      </sc-flex>
      <div>
        <button matButton (click)="download()">Download Registrierung</button>
      </div>
    </mat-card>

</div>
